<template>
  <div class="search-options-data">
    <el-collapse v-model="activeNames">
      <el-collapse-item @mousedown.native="collapseMouseDown($event, '1')" title="配置搜索" name="1">
        <div class="setting-item">
          <div class="clearFloat" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '1')">
            <div class="goManageBack mt16" @click="setClick()">配置搜索</div>
            <div class="getDataBtn mt16" @click="btnClick()">查看数据响应结果</div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item @mousedown.native="collapseMouseDown($event, '1')" title="字段匹配" name="2">
        <div class="setting-item">
          <div class="verticallyCenter">
            <span class="mr16">一级标签</span>
            <div class="select-box flex1">
              <el-select v-model="firstField" placeholder="一级标签">
                <el-option v-for="(item, index) in fieldList1" :key="index" :value="item.value" :label="item.title"
                  >{{ item.title }}
                </el-option>
              </el-select>
              <span class="del-btn icon-portal-close-one" @click="clearClick(1)"></span>
            </div>
          </div>
          <div class="verticallyCenter mt8">
            <span class="mr16">二级标签</span>
            <div class="select-box flex1">
              <el-select v-model="secondField" placeholder="二级标签">
                <el-option v-for="(item, index) in fieldList2" :key="index" :value="item.value" :label="item.title"
                  >{{ item.title }}
                </el-option>
              </el-select>
              <span class="del-btn icon-portal-close-one" @click="clearClick(2)"></span>
            </div>
          </div>
          <div class="verticallyCenter mt8">
            <span class="mr16">三级标签</span>
            <div class="select-box flex1">
              <el-select v-model="thirdField" placeholder="三级标签">
                <el-option v-for="(item, index) in fieldList3" :key="index" :value="item.value" :label="item.title"
                  >{{ item.title }}
                </el-option>
              </el-select>
              <span class="del-btn icon-portal-close-one" @click="clearClick(3)"></span>
            </div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import Qs from "qs"
import $ from "jquery"
import { getAllColsUidInLayoutComponent, handleFindLayoutComponentOptions } from "utils"
export default {
  name: "search-options-data",
  data() {
    return {
      activeNames: ["1", "2"],
      collapseActiveNames: ["1", "2"],
      fieldList: [
        { value: "3", title: "下拉框" },
        { value: "1", title: "筛选项1" },
        { value: "2", title: "筛选项2" }
      ],
      searchTypeList: [],
      selectIndex: 0,
      tabIndex: 0,
      radioIndex: 0,
      selectOptions: [],
      searchList: [],
      that: this
    }
  },
  created() {
    setTimeout(() => {
      // this.selectClick()
      // this.tabClick()
      // this.radioClick()
    }, 100)
    this.getFieldList()
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    getOptions: function () {
      return this.$getOptions(this.ids)
    },
    firstField: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "firstField", "firstField", "3")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "firstField", false)
      }
    },
    secondField: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "secondField", "secondField", "1")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "secondField", false)
      }
    },
    thirdField: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "thirdField", "thirdField", "2")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thirdField", false)
        console.log("this.thirdField :>>", this.thirdField)
      }
    },
    fieldList1() {
      return this.fieldList.filter(item => {
        return item.value != this.secondField && item.value != this.thirdField
      })
    },
    fieldList2() {
      return this.fieldList.filter(item => {
        return item.value != this.firstField && item.value != this.thirdField
      })
    },
    fieldList3() {
      return this.fieldList.filter(item => {
        return item.value != this.firstField && item.value != this.secondField
      })
    }
  },
  methods: {
    setOpacity(type, opacityVue) {
      const getElement = this.getElementInLayout()
      let showIndex = getElement.searchElementInLayout.findIndex(item => {
        return item.searchType === type
      })
      this.$changeOptionsEV(opacityVue, "opacity", false, null, {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        uid: getElement.searchUid,
        elementInLayoutId: getElement.searchElementInLayout[showIndex].elementInLayoutId
      })
    },
    getFieldList() {
      //根据组件判断下拉选项有哪些
      this.fieldList = []
      const getElement = this.getElementInLayout()
      let selectShow = getElement.searchElementInLayout.findIndex(item => {
        return item.searchType === "searchSelect"
      })
      let tabShow = getElement.searchElementInLayout.findIndex(item => {
        return item.searchType === "searchTabs"
      })
      let radioShow = getElement.searchElementInLayout.findIndex(item => {
        return item.searchType === "searchRadio"
      })
      if (selectShow != -1) {
        this.fieldList.push({ value: "3", title: "下拉框" })
        this.selectElement = $(
          `.container_id_${getElement.searchMsg.container_id}-rect_id_${getElement.searchMsg.rect_id}-uid_${getElement.searchUid}-elementInLayoutId_${getElement.searchElementInLayout[selectShow].elementInLayoutId}`
        )
      } else {
        if (this.firstField == "3") this.firstField = ""
        if (this.secondField == "3") this.secondField = ""
        if (this.thirdField == "3") this.thirdField = ""
      }
      if (tabShow != -1) {
        this.fieldList.push({ value: "1", title: "筛选项1" })
        this.tabElement = $(
          `.container_id_${getElement.searchMsg.container_id}-rect_id_${getElement.searchMsg.rect_id}-uid_${getElement.searchUid}-elementInLayoutId_${getElement.searchElementInLayout[tabShow].elementInLayoutId}`
        )
      } else {
        if (this.firstField == "1") this.firstField = ""
        if (this.secondField == "1") this.secondField = ""
        if (this.thirdField == "1") this.thirdField = ""
      }
      if (radioShow != -1) {
        this.fieldList.push({ value: "2", title: "筛选项2" })
        this.radioElement = $(
          `.container_id_${getElement.searchMsg.container_id}-rect_id_${getElement.searchMsg.rect_id}-uid_${getElement.searchUid}-elementInLayoutId_${getElement.searchElementInLayout[radioShow].elementInLayoutId}`
        )
      } else {
        if (this.firstField == "2") this.firstField = ""
        if (this.secondField == "2") this.secondField = ""
        if (this.thirdField == "2") this.thirdField = ""
      }
    },
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    async setClick() {
      const { pageId, wfwfid, websiteId } = { ...this.$store.state.states.getDataPageIds }
      const params = {
        a: "A2FCFFD092A210FC",
        w: wfwfid,
        p: pageId
      }
      let appId = this.getOptions.appId
      if (!appId) appId = await this.getAppId(params)
      this.$changeOptionsEV(appId, "appId", false)
      window.open(`/engine2/data/api-v2/admin/search/${appId}?w=${websiteId}&p=${pageId}`)
    },
    // 获取appId
    async getAppId(params) {
      return new Promise((resolve, reject) => {
        this.instance({
          method: "post",
          url: "v2/default-app",
          headers: {
            "Content-type": "application/x-www-form-urlencoded"
          },
          data: Qs.stringify(params)
        }).then(res => {
          if (res.data.code === 1) {
            resolve(res.data.data.appId)
          } else {
            reject("err")
          }
        })
      })
    },
    btnClick() {
      const getElement = this.getElementInLayout()
      this.getFieldList()
      this.startDraw()
    },
    async startDraw() {
      const that = this
      let appId = this.getOptions.appId
      if (!appId) {
        this.$message({
          type: "error",
          message: "请进入数据管理后台添加数据"
        })
        return
      }
      // 当字段匹配为空时 隐藏相应的组件
      if (this.firstField != "1" && this.secondField != "1" && this.thirdField != "1") {
        this.tabElement.hide()
        this.setOpacity("searchTabs", 0)
      } else {
        this.tabElement.show()
        this.setOpacity("searchTabs", 100)
      }
      if (this.firstField != "2" && this.secondField != "2" && this.thirdField != "2") {
        this.radioElement.hide()
        this.setOpacity("searchRadio", 0)
      } else {
        this.radioElement.show()
        this.setOpacity("searchRadio", 100)
      }
      if (this.firstField != "3" && this.secondField != "3" && this.thirdField != "3") {
        this.selectElement.hide()
        this.setOpacity("searchSelect", 0)
      } else {
        this.selectElement.show()
        this.setOpacity("searchSelect", 100)
      }
      this.searchList = await this.getSearchList(appId)
      if (this.searchList == "err") return
      if (this.searchList.length == 0) {
        this.$message({
          type: "error",
          message: "请进入数据管理后台添加数据"
        })
        return
      }
      this.setSearchList(this.searchList, this.tabIndex, this.radioIndex, this.selectIndex)
      const getElement = this.getElementInLayout()
      getElement.searchElementInLayout.forEach(element => {
        switch (element.searchType) {
          case "searchTabs":
            this.tabIndex = element.activeIndex
            if (this.firstField == "1") {
              this.selectOptions = element.tabsList
            }
            break
          case "searchSelect":
            if (this.firstField == "3") {
              this.selectIndex = element.selectOptions.findIndex(item => item.label === element.value)
              this.selectOptions = element.selectOptions
            }
            break
          case "searchRadio":
            this.radioIndex = element.activeIndex
            if (this.firstField == "2") {
              this.selectOptions = element.radioLists
            }
            break
          default:
            break
        }
      })
      this.selectClick()
      this.tabClick()
      this.radioClick()
    },
    // 点击下拉切换
    selectClick() {
      const that = this
      setTimeout(() => {
        $(`.container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}`)
          .find(".cx-select>.el-select .el-select-dropdown__item")
          .on("click", function () {
            that.firstField = that.getElementInLayout().searchOptions.firstField
            that.secondField = that.getElementInLayout().searchOptions.secondField
            that.thirdField = that.getElementInLayout().searchOptions.thirdField
            if (that.selectIndex == $(this).index()) {
              return
            }
            if (that.firstField == "3") {
              const typeId = that.selectOptions[$(this).index()].value
              that.selectFun(typeId, that.tabIndex, that.radioIndex, $(this).index())
            } else if (that.secondField == "3") {
              // 判断是否需要获取搜索引擎
              if (that.searchTypeList.length > 0)
                that.setSearchTypeList(that.searchTypeList, that.tabIndex, that.radioIndex, $(this).index())
              else that.setSearchList(that.searchList, that.tabIndex, that.radioIndex, $(this).index())
            }
            that.selectIndex = $(this).index()
            // 切换后重新给tab绑定事件 不然不能点击
            if (!(that.thirdField === "3")) {
              that.tabClick()
              that.radioClick()
            }
          })
      }, 100)
    },
    async selectFun(typeId, index1, index2, index3) {
      const that = this
      that.searchTypeList = await that.getSearchTypeList(typeId)
      if (that.searchTypeList == "err") return
      that.setSearchTypeList(that.searchTypeList, index1, index2, index3)
    },
    // 点击tab切换
    tabClick() {
      const that = this
      setTimeout(() => {
        $(`.container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}`)
          .find(".tab")
          .on("click", function () {
            // 不知道为啥点击渲染数据之后这三个值就被重置了 所以重新赋值
            that.firstField = that.getElementInLayout().searchOptions.firstField
            that.secondField = that.getElementInLayout().searchOptions.secondField
            that.thirdField = that.getElementInLayout().searchOptions.thirdField
            if (that.tabIndex == $(this).index()) {
              return
            }
            if (that.firstField === "1") {
              that.selectIndex = 0 //重置下拉选中项
              that.radioIndex = 0 //重置单选选中项
              const typeId = that.selectOptions[$(this).index()].value
              that.selectFun(typeId, $(this).index(), that.radioIndex, that.selectIndex)
            } else if (that.secondField === "1") {
              // 判断是否需要获取搜索引擎
              if (that.searchTypeList.length > 0)
                that.setSearchTypeList(that.searchTypeList, $(this).index(), that.radioIndex, that.selectIndex)
              else that.setSearchList(that.searchList, $(this).index(), that.radioIndex, that.selectIndex)
            }
            that.tabIndex = $(this).index()
            // 切换后重新绑定事件 不然不能点击
            if (!(that.thirdField === "1")) {
              that.selectClick()
              that.radioClick()
            }
          })
      }, 100)
    },
    // 点击radio切换
    radioClick() {
      const that = this
      setTimeout(() => {
        $(`.container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}`)
          .find(".radio")
          .on("click", function () {
            that.firstField = that.getElementInLayout().searchOptions.firstField
            that.secondField = that.getElementInLayout().searchOptions.secondField
            that.thirdField = that.getElementInLayout().searchOptions.thirdField
            if (that.radioIndex == $(this).index()) {
              return
            }
            if (that.firstField === "2") {
              const typeId = that.selectOptions[$(this).index()].value
              that.selectFun(typeId, that.tabIndex, $(this).index(), that.selectIndex)
            } else if (that.secondField === "2") {
              // 判断是否需要获取搜索引擎
              if (that.searchTypeList.length > 0)
                that.setSearchTypeList(that.searchTypeList, that.tabIndex, $(this).index(), that.selectIndex)
              else that.setSearchList(that.searchList, that.tabIndex, $(this).index(), that.selectIndex)
            }
            that.radioIndex = $(this).index()
            // 切换后重新绑定事件 不然不能点击
            if (!(that.thirdField === "2")) {
              that.selectClick()
              that.tabClick()
            }
          })
      }, 100)
    },
    // 获取搜索基本组件
    getElementInLayout() {
      const searchMsg = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id
      }
      const rectAttr = this.getRectAttribute.call(this, searchMsg)
      const searchOptions = [rectAttr.options.rows[0]]
      const searchUid = getAllColsUidInLayoutComponent(searchOptions)[0]
      const searchElementInLayout = handleFindLayoutComponentOptions(searchOptions, searchUid)
      return {
        searchOptions: rectAttr.options,
        searchMsg: searchMsg,
        searchUid: searchUid,
        searchElementInLayout: searchElementInLayout
      }
    },
    // 获取数据
    async getSearchList(appId) {
      return new Promise((resolve, reject) => {
        this.$API
          .querySearchEngineList({
            appId: appId
          })
          .then(res => {
            if (res.data.code === 1) {
              if (res.data.data) resolve(res.data.data.datas)
              else resolve([])
            } else {
              reject("err")
            }
          })
      })
    },
    // 查询引擎下分类
    async getSearchTypeList(typeId) {
      return new Promise((resolve, reject) => {
        this.$API
          .querySearchEngineClassify({
            typeId: typeId
          })
          .then(res => {
            if (res.data.code === 1) {
              resolve(res.data.data.searchTypeList)
            } else {
              reject("err")
            }
          })
      })
    },
    // 渲染搜索引擎组件基本信息
    setSearchList(searchList, tabIndex, radioIndex, selectIndex) {
      if (searchList.length === 0) return
      const getElement = this.getElementInLayout()
      const selectList = []
      if (Array.isArray(searchList)) {
        searchList.forEach(item => {
          selectList.push({
            label: item.name,
            value: item.encId,
            link: item.link,
            name: item.name,
            content: item.id
          })
        })
      }
      getElement.searchElementInLayout.forEach(element => {
        if (this.firstField == "3") {
          switch (element.searchType) {
            case "searchSelect":
              this.$changeOptionsEV(selectList, "selectOptions", false, null, {
                uid: getElement.searchUid,
                elementInLayoutId: element.elementInLayoutId,
                ...getElement.searchMsg
              })
              // 返回第一个搜索引擎的值
              let label = selectList.length > 0 ? (selectList[0] ? selectList[0].label : selectList[0].label) : ""
              this.$changeOptionsEV(label, "value", false, null, {
                uid: getElement.searchUid,
                elementInLayoutId: element.elementInLayoutId,
                ...getElement.searchMsg
              })
              break
            default:
              break
          }
        } else if (this.firstField == "1") {
          switch (element.searchType) {
            case "searchTabs":
              this.$changeOptionsEV(selectList, "tabsList", false, null, {
                uid: getElement.searchUid,
                elementInLayoutId: element.elementInLayoutId,
                ...getElement.searchMsg
              })
              this.$changeOptionsEV(tabIndex, "activeIndex", false, null, {
                uid: getElement.searchUid,
                elementInLayoutId: element.elementInLayoutId,
                ...getElement.searchMsg
              })
              break
            default:
              break
          }
        } else if (this.firstField == "2") {
          switch (element.searchType) {
            case "searchRadio":
              this.$changeOptionsEV(selectList, "radioLists", false, null, {
                uid: getElement.searchUid,
                elementInLayoutId: element.elementInLayoutId,
                ...getElement.searchMsg
              })
              this.$changeOptionsEV(radioIndex, "activeIndex", false, null, {
                uid: getElement.searchUid,
                elementInLayoutId: element.elementInLayoutId,
                ...getElement.searchMsg
              })
              break
            default:
              break
          }
        }
      })
      let listIdx = 0
      if (this.firstField == "1") {
        listIdx = tabIndex
      } else if (this.firstField == "2") {
        listIdx = radioIndex
      } else if (this.firstField == "3") {
        listIdx = selectIndex
      }
      this.setSearchTypeList(searchList[listIdx].searchTypeList, tabIndex, radioIndex, selectIndex)
    },
    // 渲染引擎下的分类
    setSearchTypeList(list, tabIndex, radioIndex, selectIndex = 0) {
      const getElement = this.getElementInLayout()
      const searchTypeList = []
      const subSearchTypeList = []
      let linkUrl = ""
      if (Array.isArray(list)) {
        list.forEach(item => {
          searchTypeList.push({
            name: item.name,
            content: item.id,
            label: item.name,
            value: item.encId,
            link: item.link
          })
        })
        if (list[tabIndex] && list[tabIndex].link) {
          linkUrl = list[tabIndex].link
        }
      }
      let secondIndex = 0
      if (this.secondField === "1") {
        secondIndex = tabIndex
      } else if (this.secondField === "2") {
        secondIndex = radioIndex
      } else if (this.secondField === "3") {
        secondIndex = selectIndex
      }
      if (list[secondIndex] && Array.isArray(list[secondIndex].subSearchTypeList)) {
        list[secondIndex].subSearchTypeList.forEach(item => {
          subSearchTypeList.push({
            name: item.name,
            content: item.id,
            label: item.name,
            value: item.encId,
            link: item.link
          })
        })
        if (list[secondIndex].subSearchTypeList[radioIndex] && list[secondIndex].subSearchTypeList[radioIndex].link) {
          linkUrl = list[secondIndex].subSearchTypeList[radioIndex].link
        }
      }
      // 当字段匹配为空时 隐藏相应的组件
      if (this.firstField != "1" && this.secondField != "1" && this.thirdField != "1") {
        this.tabElement.hide()
        this.setOpacity("searchTabs", 0)
      }
      if (this.firstField != "2" && this.secondField != "2" && this.thirdField != "2") {
        this.radioElement.hide()
        this.setOpacity("searchRadio", 0)
      }
      if (this.firstField != "3" && this.secondField != "3" && this.thirdField != "3") {
        this.selectElement.hide()
        this.setOpacity("searchSelect", 0)
      }
      getElement.searchElementInLayout.forEach(element => {
        switch (element.searchType) {
          case "searchInput":
            linkUrl = linkUrl + "&sw=" + encodeURIComponent(element.inputValue)
            break
          case "searchButton":
            this.$changeOptionsEV(linkUrl, "linkUrl", false, null, {
              uid: getElement.searchUid,
              elementInLayoutId: element.elementInLayoutId,
              ...getElement.searchMsg
            })
            break
          default:
            break
        }
        // 二级标签
        if (this.secondField == "1") {
          if (searchTypeList.length > 0) {
            this.tabElement.show()
            this.setOpacity("searchTabs", 100)
          } else {
            this.tabElement.hide()
            this.setOpacity("searchTabs", 0)
          }
          switch (element.searchType) {
            case "searchTabs":
              this.$changeOptionsEV(searchTypeList, "tabsList", false, null, {
                uid: getElement.searchUid,
                elementInLayoutId: element.elementInLayoutId,
                ...getElement.searchMsg
              })
              this.$changeOptionsEV(tabIndex, "activeIndex", false, null, {
                uid: getElement.searchUid,
                elementInLayoutId: element.elementInLayoutId,
                ...getElement.searchMsg
              })
              break
            default:
              break
          }
        } else if (this.secondField == "2") {
          if (searchTypeList.length > 0) {
            this.radioElement.show()
            this.setOpacity("searchRadio", 100)
          } else {
            this.radioElement.hide()
            this.setOpacity("searchRadio", 0)
          }
          switch (element.searchType) {
            case "searchRadio":
              this.$changeOptionsEV(searchTypeList, "radioLists", false, null, {
                uid: getElement.searchUid,
                elementInLayoutId: element.elementInLayoutId,
                ...getElement.searchMsg
              })
              this.$changeOptionsEV(radioIndex, "activeIndex", false, null, {
                uid: getElement.searchUid,
                elementInLayoutId: element.elementInLayoutId,
                ...getElement.searchMsg
              })
              break
            default:
              break
          }
        } else if (this.secondField == "3") {
          if (searchTypeList.length > 0) {
            this.selectElement.show()
            this.setOpacity("searchSelect", 100)
          } else {
            this.selectElement.hide()
            this.setOpacity("searchSelect", 0)
          }
          switch (element.searchType) {
            case "searchSelect":
              this.$changeOptionsEV(searchTypeList, "selectOptions", false, null, {
                uid: getElement.searchUid,
                elementInLayoutId: element.elementInLayoutId,
                ...getElement.searchMsg
              })
              let label =
                searchTypeList.length > 0
                  ? searchTypeList[selectIndex]
                    ? searchTypeList[selectIndex].label
                    : searchTypeList[0].label
                  : ""
              // 返回第一个搜索引擎的值
              this.$changeOptionsEV(label, "value", false, null, {
                uid: getElement.searchUid,
                elementInLayoutId: element.elementInLayoutId,
                ...getElement.searchMsg
              })
              break
            default:
              break
          }
        }
        // 三级标签
        if (this.thirdField == "1") {
          if (subSearchTypeList.length > 0) {
            this.tabElement.show()
            this.setOpacity("searchTabs", 100)
          } else {
            this.tabElement.hide()
            this.setOpacity("searchTabs", 0)
          }
          switch (element.searchType) {
            case "searchTabs":
              this.$changeOptionsEV(subSearchTypeList, "tabsList", false, null, {
                uid: getElement.searchUid,
                elementInLayoutId: element.elementInLayoutId,
                ...getElement.searchMsg
              })
              this.$changeOptionsEV(tabIndex, "activeIndex", false, null, {
                uid: getElement.searchUid,
                elementInLayoutId: element.elementInLayoutId,
                ...getElement.searchMsg
              })
              break
            default:
              break
          }
        } else if (this.thirdField == "2") {
          if (subSearchTypeList.length > 0) {
            this.radioElement.show()
            this.setOpacity("searchRadio", 100)
          } else {
            this.radioElement.hide()
            this.setOpacity("searchRadio", 1)
          }
          switch (element.searchType) {
            case "searchRadio":
              this.$changeOptionsEV(subSearchTypeList, "radioLists", false, null, {
                uid: getElement.searchUid,
                elementInLayoutId: element.elementInLayoutId,
                ...getElement.searchMsg
              })
              this.$changeOptionsEV(radioIndex, "activeIndex", false, null, {
                uid: getElement.searchUid,
                elementInLayoutId: element.elementInLayoutId,
                ...getElement.searchMsg
              })
              break
            default:
              break
          }
        } else if (this.thirdField == "3") {
          if (subSearchTypeList.length > 0) {
            this.selectElement.show()
            this.setOpacity("searchSelect", 100)
          } else {
            this.selectElement.hide()
            this.setOpacity("searchSelect", 0)
          }
          switch (element.searchType) {
            case "searchSelect":
              this.$changeOptionsEV(subSearchTypeList, "selectOptions", false, null, {
                uid: getElement.searchUid,
                elementInLayoutId: element.elementInLayoutId,
                ...getElement.searchMsg
              })
              // 返回第一个搜索引擎的值
              let label =
                subSearchTypeList.length > 0
                  ? subSearchTypeList[selectIndex]
                    ? subSearchTypeList[selectIndex].label
                    : subSearchTypeList[0].label
                  : ""
              this.$changeOptionsEV(label, "value", false, null, {
                uid: getElement.searchUid,
                elementInLayoutId: element.elementInLayoutId,
                ...getElement.searchMsg
              })
              break
            default:
              break
          }
        }
      })
    },
    clearClick(type) {
      console.log("type :>>", type)
      switch (type) {
        case 1:
          this.firstField = ""
          this.secondField = ""
          this.thirdField = ""
          break
        case 2:
          this.secondField = ""
          this.thirdField = ""
          break
        case 3:
          this.thirdField = ""
          break
        default:
      }
    }
  }
}
</script>

<style>
.goManageBack {
  display: block;
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  width: 100%;
  height: 32px;
  font-size: 14px;
  line-height: 30px;
  color: var(--themeColor);
  text-align: center;
  cursor: pointer;
}
.getDataBtn {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #fff;
  padding: 6px 0px;
  cursor: pointer;
}
.select-box {
  position: relative;
}
.select-box .del-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: rgba(0, 0, 0, 0.2);
  background: var(--inputBackGround);
  display: none;
}
.select-box:hover .del-btn {
  display: block;
}
</style>
